module.exports = __webpack_public_path__ + "img/square-code.9b77f170.svg";